import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../../../../Icon';
import {
  ItemTitle,
  ItemIcons,
  ItemDesc,
  LabelContainer,
  LabelText,
  buttonStyles
} from './styled';
import { PromotionItemContent, PromotionSectionItem } from '../styled';
import { Button } from '../../../../../ui/Button';
import { PromotionServiceId } from '../../../../../types/promotion';
import { VIP_OR_FEATURE_IDS } from '../../../../../../utils/helpers/constants';
import { AuthorButtonProps } from '../../types';

const promotionAuthorButtonStat = {
  [PromotionServiceId.Bump]: 'product-service-bump-lister',
  [PromotionServiceId.Vip]: 'product-service-vip-lister',
  [PromotionServiceId.Feature]: 'product-service-featured-lister'
};

export const AuthorButton: React.FC<AuthorButtonProps> = ({
  title,
  icons,
  description,
  price,
  onClickHandler,
  isAuthor,
  id
}) => {
  const { t } = useTranslation();
  const isLabeled = VIP_OR_FEATURE_IDS.includes(id);
  const isVip = id === PromotionServiceId.Vip;

  return (
    <PromotionSectionItem
      onClick={onClickHandler}
      $isAuthor={isAuthor}
      data-cy={`prom-section__item${isAuthor ? '' : '--not-author'}`}
      data-stat={promotionAuthorButtonStat[id]}
    >
      <PromotionItemContent data-cy="prom-section__item-content">
        <div>
          <ItemTitle
            tag="title_6_new"
            data-cy="prom-section__item-content_title"
          >
            {title}
          </ItemTitle>

          <ItemIcons>
            {icons.map((icon, i) => (
              <Icon
                key={i}
                width={15}
                height={13}
                IconComponent={icon}
                indent={false}
              />
            ))}
          </ItemIcons>
        </div>

        <ItemDesc
          tag="caption_4_new"
          $isLabeled={isLabeled}
          data-cy="prom-section__item-content_desc"
        >
          {description}
        </ItemDesc>
      </PromotionItemContent>

      <Button
        onClick={onClickHandler}
        text={price}
        cypress="prom-section__item-button"
        styles={buttonStyles}
      />

      {isLabeled && (
        <LabelContainer $type={id}>
          <LabelText tag="caption_4_new">
            {t('pages.current_item.promotion.bump_every_day')}
          </LabelText>

          {!isVip && <LabelText tag="caption_4_new">VIP</LabelText>}
        </LabelContainer>
      )}
    </PromotionSectionItem>
  );
};
